var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgManagerHomeActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.4334 1.80362L3.4905 7.87836L3.34541 8.01406C2.79806 8.56614 2.50073 9.26154 2.5 9.98741V18.4579L2.50554 18.6255C2.61824 20.2117 4.05856 21.4 5.76712 21.4H9.83923C10.2077 21.4 10.5065 21.1013 10.5065 20.7328L10.5075 14.6001L10.5128 14.5032C10.543 14.1953 10.8303 13.9327 11.1748 13.9327H14.2252L14.3221 13.9381C14.63 13.9683 14.8925 14.2556 14.8925 14.6L14.8916 20.7326C14.8915 21.1012 15.1903 21.4 15.5589 21.4H19.6329L19.8155 21.3953C21.5354 21.3016 22.9 20.0354 22.9 18.4579V9.98808L22.8925 9.7962C22.8306 9.04826 22.4796 8.37656 21.9092 7.87809L14.9766 1.81222L14.7863 1.66252C13.5053 0.730537 11.6443 0.785685 10.4334 1.80362Z",
  fill: "#6467EF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgManagerHomeActive);
export default ForwardRef;